<template>
  <van-popup v-model="showPage" position="bottom" class="progressTopInfo" @close="onClosed">
    <van-row class="popTitle">
      <van-col span="4" />
      <van-col span="16" class="center" :style="'color:'+GetDiveMainBack()">行程订单日志</van-col>
      <van-col span="4" class="rigth"><i class="iconfont iconrigthjt" @click="showPage=false" /></van-col>
    </van-row>
    <div class="dataRect editRect">

      <van-row gutter="10" class="values">
        <van-col span="5"><span :style="'color:'+GetDiveMainBack()">日志</span></van-col>
        <van-col span="19">
          <van-field v-model="LogForm.body" style="padding:0" placeholder="请输入日志内容" type="textarea" rows="3" autosize maxlength="256" show-word-limit />
        </van-col>
      </van-row>
      <van-row gutter="10" class="values">
        <van-col span="5"><span :style="'color:'+GetDiveMainBack()">可见性</span></van-col>
        <van-col span="19">
          <van-switch v-model="LogForm.isPublic" size="2em" :active-color="GetDiveMainBack()" :inactive-color="GetColorSecondary()" />
          <span style="padding-left:1em;">{{ LogForm.isPublic?"用户可见":"用户不可见" }}</span>
        </van-col>
      </van-row>
      <van-row gutter="10">
        <van-col span="12"><van-button :color="GetColorSecondary()" size="small" style="width:100%" :loading="buttonLoading" @click="onCLean">清空</van-button></van-col>
        <van-col span="12"><van-button :color="GetDiveMainBack()" size="small" style="width:100%" :loading="buttonLoading" @click="obSubject">添加日志</van-button></van-col>
      </van-row>
    </div>
  </van-popup>
</template>
<script>
import request from '@/utils/request'
import { Button, Popup, Field, Dialog, Switch } from 'vant'
import { GetEnumList, formatDate, GetEnumText, MyNotify, getScoreText, GetDiveMainBack, GetColorMain, GetColorSecondary, GetDiveTitle, GetColorMainLine } from '@/utils/base'
// import { formatDate } from '@/utils/base'
export default {
  components: {
    [Button.name]: Button,
    [Popup.name]: Popup,
    [Field.name]: Field,
    [Dialog.name]: Dialog,
    [Switch.name]: Switch
  },
  props: {
    // eslint-disable-next-line
    value: String,
  },
  data() {
    return {
      showPage: false,
      buttonLoading: false,
      diveOrderId: undefined,
      LogForm: {
        diveOrderId: undefined,
        body: '',
        isPublic: false
      }
    }
  },
  watch: {
    value(newValue) {
      if (newValue) {
        this.diveOrderId = newValue
        this.LogForm.diveOrderId = newValue
        this.onCLean()
        this.showPage = true
      } else {
        this.diveOrderId = undefined
        this.LogForm.diveOrderId = undefined
        this.showPage = false
      }
    }

  },
  created() {

  },
  methods: {
    GetEnumList,
    formatDate,
    GetEnumText,
    MyNotify,
    getScoreText,
    GetDiveMainBack,
    GetColorMain,
    GetColorSecondary,
    GetDiveTitle,
    GetColorMainLine,
    onClosed() {
      console.log('onClosed')
      this.$emit('input', undefined)
    },
    obSubject() {
      if (!this.LogForm.body) {
        MyNotify('warning', '请输入日志内容', 2000)
        return
      }
      this.buttonLoading = true
      request({
        url: '/DiveTrip/addDiveOrderCoachLog',
        method: 'post',
        data: this.LogForm
      }).then(Response => {
        this.buttonLoading = false
        if (!Response.success) {
          return
        }
        MyNotify('success', '添加行程日志成功', 2000)
        this.$emit('reload')
        this.showPage = false
      })
    },
    onCLean() {
      this.LogForm.body = ''
      this.LogForm.isPublic = false
    }
  }
}
</script>

<style scoped>
.progressTopInfo{
  box-shadow: 2px 2px 2px 1px rgba(0, 0, 0, 0.2);
}
.progressTopInfo .dataRect
{
  padding: 0 0.5em;
  overflow: hidden;
  font-size: 0.8em;
  line-height: 1.5em;
}
.progressTopInfo .editRect
{
  padding-top: 0.5em;
  padding-bottom: 1em;
  line-height: 2.5em;
}
.progressTopInfo .popTitle
{
  padding: 0.5em 0.5em;
  border-bottom: 1px solid #f5f5f5;
}

</style>
